/* DBZ Brand Discovery (Empire-safe)
   - Requires the HTML elements to exist (dbz-brand-bar markup)
   - Requires window.__ALL_BRANDS__ injected via Liquid in the snippet
   - Idempotent init to avoid double-binding in section reloads
*/

(function () {
  // Prevent double init (Empire can re-render sections)
  if (window.__dbzBrandInitDone) return;
  window.__dbzBrandInitDone = true;

  function brandToSlug(brand) {
    return String(brand || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/['’]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  // ✅ Choose ONE behavior:
  // Option A (recommended): dedicated brand pages
   // function brandToUrl(brand) {
   // return "/collections/" + brandToSlug(brand);
    // }

  // Option B (quick fallback): vendor collection search
  function brandToUrl(brand) {
  return "/collections/vendors?q=" + encodeURIComponent(brand);
}


  function normalizeForSearch(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getGroupKey(brand) {
    const b = String(brand || "").trim();
    if (!b) return "#";
    const ch = b.charAt(0);
    if (/[0-9]/.test(ch)) return "#";
    const up = ch.toUpperCase();
    if (/[A-Z]/.test(up)) return up;
    return "#";
  }

  function dedupeAndSort(brandsRaw) {
    const map = new Map();
    for (const b of brandsRaw) {
      const pretty = String(b || "").trim();
      if (!pretty) continue;
      const key = normalizeForSearch(pretty);
      if (!map.has(key)) map.set(key, pretty);
    }
    return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
  }

  function buildGroups(brands) {
    const groups = {};
    for (const b of brands) {
      const k = getGroupKey(b);
      if (!groups[k]) groups[k] = [];
      groups[k].push(b);
    }
    Object.keys(groups).forEach((k) =>
      groups[k].sort((a, b) => a.localeCompare(b))
    );
    return groups;
  }

  const INDEX_KEYS = ["#", ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))];

  function $(id) {
    return document.getElementById(id);
  }

  function safeHtml(text) {
    // For text nodes we don't need HTML, but keep helper in case.
    return String(text).replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }[m]));
  }

  function init() {
    // Elements (must exist)
    const azStrip = $("dbzAZStrip");
    const brandList = $("dbzBrandList");
    const brandSearch = $("dbzBrandSearch");

    const modal = $("dbzBrandModal");
    const backdrop = $("dbzModalBackdrop");

    const searchOverlay = $("dbzSearchOverlay");
    const globalSearchInput = $("dbzGlobalSearchInput");
    const globalSearchResults = $("dbzGlobalSearchResults");

    const btnOpenBrands = $("dbzOpenBrands");
    const btnCloseBrands = $("dbzCloseBrands");

    const btnOpenSearch = $("dbzOpenSearch");
    const btnCloseSearch = $("dbzCloseSearch");

    // If markup isn’t on this page, do nothing.
    if (!azStrip || !brandList || !brandSearch || !modal || !backdrop) return;

    // Load brands injected via Liquid snippet
    const raw = Array.isArray(window.__ALL_BRANDS__) ? window.__ALL_BRANDS__ : [];
    const ALL_BRANDS = dedupeAndSort(raw);
    const GROUPS = buildGroups(ALL_BRANDS);

    function groupTitleEl(title) {
      const t = document.createElement("div");
      t.className = "dbz-group__title";
      t.textContent = title;
      return t;
    }

    function brandItemEl(brand) {
      const row = document.createElement("div");
      row.className = "dbz-item";
      row.setAttribute("role", "listitem");

      const a = document.createElement("a");
      a.className = "dbz-link";
      a.href = brandToUrl(brand);

      const left = document.createElement("span");
      left.textContent = brand;

      const right = document.createElement("span");
      right.textContent = "›";

      a.appendChild(left);
      a.appendChild(right);
      row.appendChild(a);
      return row;
    }

    function setActiveAZ(key) {
      azStrip.querySelectorAll(".dbz-az__btn").forEach((b) => {
        b.classList.toggle("is-active", b.dataset.key === key);
      });
    }

    function scrollToGroup(key) {
      const el = document.getElementById("dbzGroup_" + key);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function renderBrandGroups(onlyKey = null) {
      brandList.innerHTML = "";
      const keysToRender = onlyKey
        ? [onlyKey]
        : INDEX_KEYS.filter((k) => GROUPS[k] && GROUPS[k].length);

      for (const key of keysToRender) {
        const brands = GROUPS[key] || [];
        if (!brands.length) continue;

        const group = document.createElement("div");
        group.className = "dbz-group";
        group.id = "dbzGroup_" + key;

        group.appendChild(groupTitleEl(key));
        for (const b of brands) group.appendChild(brandItemEl(b));
        brandList.appendChild(group);
      }
    }

    function renderAZ(activeKey) {
      azStrip.innerHTML = "";
      for (const key of INDEX_KEYS) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "dbz-az__btn" + (key === activeKey ? " is-active" : "");
        btn.textContent = key;
        btn.dataset.key = key;

        btn.addEventListener("click", () => {
          brandSearch.value = "";
          renderBrandGroups(key);
          setActiveAZ(key);
          scrollToGroup(key);
        });

        azStrip.appendChild(btn);
      }
    }

    function renderSearchResults(q) {
      const nq = normalizeForSearch(q);
      brandList.innerHTML = "";

      if (!nq) {
        renderBrandGroups("#"); // default to # so 4711 is instantly available
        setActiveAZ("#");
        return;
      }

      const matched = ALL_BRANDS.filter((b) =>
        normalizeForSearch(b).includes(nq)
      );

      if (!matched.length) {
        const wrap = document.createElement("div");
        wrap.className = "dbz-group";
        const msg = document.createElement("div");
        msg.className = "dbz-results__empty";
        msg.textContent = "No matching brands.";
        wrap.appendChild(msg);
        brandList.appendChild(wrap);
        return;
      }

      const group = document.createElement("div");
      group.className = "dbz-group";
      group.appendChild(groupTitleEl("Results"));
      matched.slice(0, 120).forEach((b) => group.appendChild(brandItemEl(b)));
      brandList.appendChild(group);
    }

    function openBrands() {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      brandSearch.value = "";
      renderAZ("#");
      renderBrandGroups("#");
      setActiveAZ("#");
      setTimeout(() => brandSearch.focus(), 0);
    }

    function closeBrands() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
    }

    function openSearch() {
      if (!searchOverlay || !globalSearchInput || !globalSearchResults) return;
      searchOverlay.classList.add("is-open");
      searchOverlay.setAttribute("aria-hidden", "false");
      globalSearchInput.value = "";
      globalSearchResults.innerHTML =
        '<div class="dbz-results__empty">Start typing a brand name (e.g., <b>Bvlgari</b>, <b>Dolce & Gabbana</b>, <b>Gucci</b>, <b>Yves Saint Laurent</b>).</div>';
      setTimeout(() => globalSearchInput.focus(), 0);
    }

    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove("is-open");
      searchOverlay.setAttribute("aria-hidden", "true");
    }

    function renderGlobalSearch(q) {
      if (!globalSearchResults) return;
      const nq = normalizeForSearch(q);
      globalSearchResults.innerHTML = "";

      if (!nq) {
        globalSearchResults.innerHTML =
          '<div class="dbz-results__empty">Start typing a brand name (e.g., <b>Bvlgari</b>, <b>Dolce & Gabbana</b>, <b>Gucci</b>, <b>Yves Saint Laurent</b>).</div>';
        return;
      }

      const brandMatches = ALL_BRANDS.filter((b) =>
        normalizeForSearch(b).includes(nq)
      ).slice(0, 8);

      if (brandMatches.length) {
        const t = document.createElement("div");
        t.className = "dbz-results__sectionTitle";
        t.textContent = "Brands";
        globalSearchResults.appendChild(t);

        brandMatches.forEach((b) => {
          const item = document.createElement("div");
          item.className = "dbz-item";

          const a = document.createElement("a");
          a.className = "dbz-link";
          a.href = brandToUrl(b);
          a.innerHTML = `<span>${safeHtml(b)}</span><span>›</span>`;

          item.appendChild(a);
          globalSearchResults.appendChild(item);
        });
      } else {
        globalSearchResults.innerHTML =
          '<div class="dbz-results__empty">No matching brands.</div>';
      }
    }

    // Bind events once (guard by dataset flag)
    if (btnOpenBrands && !btnOpenBrands.dataset.dbzBound) {
      btnOpenBrands.addEventListener("click", function (e) {
  e.preventDefault();
  e.stopPropagation();
  openBrands();
});
      btnOpenBrands.dataset.dbzBound = "1";
    }
    if (btnCloseBrands && !btnCloseBrands.dataset.dbzBound) {
      btnCloseBrands.addEventListener("click", closeBrands);
      btnCloseBrands.dataset.dbzBound = "1";
    }
    if (!backdrop.dataset.dbzBound) {
      backdrop.addEventListener("click", closeBrands);
      backdrop.dataset.dbzBound = "1";
    }

    if (btnOpenSearch && !btnOpenSearch.dataset.dbzBound) {
      btnOpenSearch.addEventListener("click", openSearch);
      btnOpenSearch.dataset.dbzBound = "1";
    }
    if (btnCloseSearch && !btnCloseSearch.dataset.dbzBound) {
      btnCloseSearch.addEventListener("click", closeSearch);
      btnCloseSearch.dataset.dbzBound = "1";
    }

    if (searchOverlay && !searchOverlay.dataset.dbzBound) {
      searchOverlay.addEventListener("click", (e) => {
        if (e.target === searchOverlay) closeSearch();
      });
      searchOverlay.dataset.dbzBound = "1";
    }

    if (!document.documentElement.dataset.dbzEscBound) {
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          if (modal.classList.contains("is-open")) closeBrands();
          if (searchOverlay && searchOverlay.classList.contains("is-open"))
            closeSearch();
        }
      });
      document.documentElement.dataset.dbzEscBound = "1";
    }

    let brandSearchTimer = null;
    if (!brandSearch.dataset.dbzBound) {
      brandSearch.addEventListener("input", () => {
        clearTimeout(brandSearchTimer);
        brandSearchTimer = setTimeout(
          () => renderSearchResults(brandSearch.value),
          80
        );
      });
      brandSearch.dataset.dbzBound = "1";
    }

    let globalSearchTimer = null;
    if (globalSearchInput && !globalSearchInput.dataset.dbzBound) {
      globalSearchInput.addEventListener("input", () => {
        clearTimeout(globalSearchTimer);
        globalSearchTimer = setTimeout(
          () => renderGlobalSearch(globalSearchInput.value),
          80
        );
      });
      globalSearchInput.dataset.dbzBound = "1";
    }
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Empire/Shopify can load sections dynamically; re-init safely
  document.addEventListener("shopify:section:load", init);
})();
